import Vue from 'vue';

if(document.getElementById("event-list")){
  new Vue({
    el: '#event-list',
    data: {
      events: events
    },
  });
}
